/* eslint-disable no-bitwise */
import { Modifiers } from "../interop/types";

export function getEventModifierKeys(event: MouseEvent | KeyboardEvent | TouchEvent | PointerEvent | WheelEvent) {
  let modifiers = 0;
  if (event.shiftKey) {
    modifiers |= Modifiers.Shift;
  }

  // need to add something for the mac here for "Mac Control"
  if (event.ctrlKey) modifiers |= Modifiers.Control;
  if (event.metaKey) modifiers |= Modifiers.Control;
  if (event.altKey) modifiers |= Modifiers.Alt;
  return modifiers;
}
